export interface VideoConfig {
  id: number;
  url: string;
  title: string;
}

export const FACILITATOR_VIDEO_CONFIG: { [key: number]: VideoConfig } = {
  1: {
    id: 1,
    title: "Set Vision-Outcome for Your Group",
    url: "https://all-ims-assets.s3.us-west-2.amazonaws.com/facilitator-videos/facilitator_1.mp4"
  },
  2: {
    id: 2,
    title: "Making Invitations",
    url: "https://all-ims-assets.s3.us-west-2.amazonaws.com/facilitator-videos/facilitator_2.mp4"
  },
  3: {
    id: 3,
    title: "Holding Space",
    url: "https://all-ims-assets.s3.us-west-2.amazonaws.com/facilitator-videos/facilitator_3.mp4"
  },
  4: {
    id: 4,
    title: "Managing Group Dynamics",
    url: "https://all-ims-assets.s3.us-west-2.amazonaws.com/facilitator-videos/facilitator_4.mp4"
  },
  5: {
    id: 5,
    title: "Growth Through Facilitation",
    url: "https://all-ims-assets.s3.us-west-2.amazonaws.com/facilitator-videos/facilitator_5.mp4"
  },
  6: {
    id: 6,
    title: "Inviting People to a Weekend",
    url: "https://all-ims-assets.s3.us-west-2.amazonaws.com/facilitator-videos/facilitator_6.mp4"
  }
};
